// extracted by mini-css-extract-plugin
export default {"laborantForm":"laborantForm_laborantForm__1waV6"};